
import ScrollTop from "./utils/ScrollTop";
import AppRouter from "./config/AppRouter";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { useSelector } from "react-redux";
import { useTelemetryHub } from './utils/useRealtimeHub';


// *********** MAIN APP WRAPPER **************
const App = () => {
  const { isAuthenticated } = useSelector(
    (state) => state.auth
  );
  useTelemetryHub(isAuthenticated);


  return (
    <>
      <AppRouter />
      <ScrollTop />
    </>
  )
}

export default App
